import type { TitleHolder } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";

type ParticipationTitleHolderInfosProps = {
  titleHolder: TitleHolder;
  className?: string;
};

export function ParticipationTitleHolderInfos({
  titleHolder,
  className,
}: ParticipationTitleHolderInfosProps) {
  const { t } = useTranslation();
  const { ownerOrganization, type, index: accountNumberIndex } = titleHolder;
  const equitySavingPlan = ownerOrganization.equitySavingPlan;
  const smallBusinessEquitySavingPlan =
    ownerOrganization.smallBusinessEquitySavingPlan;

  return (
    <span className={cn("body200-regular text-pretty text-black", className)}>
      <strong>N° {accountNumberIndex ?? 0} </strong>
      <span>{ownerOrganization.name} - </span>
      {equitySavingPlan && (
        <span>PEA N° {equitySavingPlan.accountNumber} - </span>
      )}
      {smallBusinessEquitySavingPlan && (
        <span>PEA-PME N° {smallBusinessEquitySavingPlan.accountNumber} - </span>
      )}
      <span>
        {t(`participations.web_app.participations_list_page.${type}`)}
      </span>
    </span>
  );
}
